export const  style = {                     
    minWidth: '300px',
    minHeight: '55px',
    border: '3px solid #D2E828',
    padding: '16px',
    color: '#fff',
    background: '#000',
    
}

export const iconTheme = {
    primary: '#D2E828' ,
    secondary: '#000',
}

export const  position= {
    position: "bottom-center"
}